import React from 'react';

// DEPENDENCIES
import clsx from 'clsx';
import trim from 'lodash/trim';
import isFunction from 'lodash/isFunction';
import { Link } from 'react-router-dom';

// GLOBAL FUNCTIONS
import { toNumber } from 'functions';
import { getByCode, getByNumeric } from 'codes.js';

// LOCAL COMPONENTS
import TableBadge from './TableBadge';
import TableIcon from './TableIcon';

// STYLES
import styles from './codeCell.module.scss';

// MAIN COMPONENT
const CodeCell = ({
  value,
  column: {
    className,
    mobileView,
    codes,
    badge = true,
    numeric = false,
    code = numeric
      ? getByNumeric(codes, toNumber(value))
      : codes?.[String(value).toLowerCase()] || getByCode(codes, trim(value)),
    tip = code?.label,
    to
  } = {},
  cell: {
    row: {
      original: row
    } = {}
  } = {},
  row: {
    original: rowProp
  } = {},
  placeholder,
  wrapper: Wrapper = to
    ? ({ children }) => <LinkWrapper to={to} row={row || rowProp || {}}>{children}</LinkWrapper>
    : ({ children }) => children
}) => {
  if (value === undefined || value === '') return <div className="text-center">{placeholder}</div>;

  return (
    <Wrapper>
      {code?.icon ? (
        <TableIcon className={className} code={code} />
      ) : (
        <TableBadge
          className={clsx('table-code', !mobileView && styles.code, code?.variant && `text-${code?.variant}`, className)}
          variant={code?.variant}
          badge={badge && code?.variant}
          tip={tip}
          value={code?.code || value}
        />
      )}
    </Wrapper>
  );
};

// EXPORT
export default CodeCell;

function LinkWrapper({ children, to: toProp, row }) {
  const to = isFunction(toProp) ? toProp(row) : toProp;
  const [pathname, anchor] = to.split('#');
  return (
    <Link
      to={pathname}
      state={{ anchor }}
      className={clsx(styles.link, 'text-decoration-none')}
    >
      {children}
    </Link>
  );
}